/** VERSION: 0.0.3 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function' && typeof lazySizes !== 'object'){
    /*! lazysizes - v4.1.8 */
    !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
    /*! ls.rias.min.ks - v4.1.8 */
    !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; /* ... lazysizes rias code unchanged ... */ });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		// Placeholder
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
		enableOTP: true,
		separateRefineByFromFilter: true,
		filterTreeMobileStyle: '',
		equal_height: boostPFSThemeConfig.custom.equal_height,
		cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
        enableAjaxCart: true,
		ajaxCartStyle: 'slide', // 'slide' or 'popup'
		showAjaxCartOnAdd: true, // Opens the ajax cart after add to cart
		autoCloseMiniCart: false, // Auto close the cart after add to cart > open cart > close cart
		autoCloseMiniCartDuration: 2000,
		selectOptionInProductItem: true, // Append the product's option inside the product item when clicking "select option"
		selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
		keepScrollState: false,
   	    enableKeepScrollbackPosition: false
    },
	selector: {
		otpButtons: '.boost-pfs-filter-product-item-image'
	},
    boostProductOptionSwatch: {
        color: {
            swatchName: 'Color',
            optionName: 'color',
            swatchDisplay: true,
            swatchType: 'swatch_color_display_type_image_color'
        },
        size: {
            swatchName: 'Size',
            optionName: 'size',
            swatchDisplay: false,
            swatchType: ''
        }
    }
};

(function() {
	/* collections that are eligible for member discounts */
	const memberCollections = new Set(['rivo-25-off', 'rivo-50-off', 'rivo-100-off', 'rivo-200-off-1']);

	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {},
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

	BoostPFS.inject(this);

	/* =========================
	   NEW: Metafield helpers
	   ========================= */
	function _normalizeBool(v) {
		if (v === true || v === 'true') return true;
		if (v === 1 || v === '1') return true;
		if (typeof v === 'string') {
			var s = v.trim().toLowerCase();
			if (s === 'yes' || s === 'on') return true;
		}
		return false;
	}

	/**
	 * Tries the common Boost metafield shapes:
	 * 1) nested object: metafields[namespace][key] = value | {value, type}
	 * 2) flat dot key: metafields["namespace.key"] = value | {value, type}
	 * 3) array of records: [{namespace,key,value,type}, ...]
	 */
	function getMetaBool(metafields, namespace, key) {
		if (!metafields) return false;

		// 1) nested object
		if (metafields[namespace]) {
			var raw = metafields[namespace][key];
			if (raw && typeof raw === 'object' && 'value' in raw) return _normalizeBool(raw.value);
			return _normalizeBool(raw);
		}

		// 2) flat dot key
		var dotKey = namespace + '.' + key;
		if (Object.prototype.hasOwnProperty.call(metafields, dotKey)) {
			var raw2 = metafields[dotKey];
			if (raw2 && typeof raw2 === 'object' && 'value' in raw2) return _normalizeBool(raw2.value);
			return _normalizeBool(raw2);
		}

		// 3) array of records
		if (Array.isArray(metafields)) {
			var rec = metafields.find(function(m){
				return (m.namespace === namespace && m.key === key) || (m.key === dotKey);
			});
			if (!rec) return false;
			var val = (rec.value !== undefined) ? rec.value : rec.val;
			return _normalizeBool(val);
		}

		return false;
	}

	function compareVariables(a, b) {
		return a.price - b.price;
	}

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		let variants = data.variants;
		variants.sort(compareVariables);
		soldOut = !data.available;
		onSale = data.compare_at_price_min > data.price_min;
		priceVaries = data.price_min != data.price_max;
		images = data.images_info;
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		data = prepareShopifyData(data);
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		itemHtml = itemHtml.replace(/{{itemFeaturedImage}}/g, buildFeaturedImage(data));
		itemHtml = itemHtml.replace(/{{itemVariantImages}}/g, buildVariantImages(data));
        itemHtml = itemHtml.replace(/{{itemtags}}/g, builditemtags(data));
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
			 typeof Integration.hascompileTemplate == 'function' &&
			 !Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(
			data,
			boostPFSFilterConfig.boostProductOptionSwatch.color.swatchName,
			boostPFSFilterConfig.boostProductOptionSwatch.color.optionName,
			boostPFSFilterConfig.boostProductOptionSwatch.color.swatchDisplay,
			boostPFSFilterConfig.boostProductOptionSwatch.color.swatchType
		));

        itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildProductOptionSwatches(
			data,
			boostPFSFilterConfig.boostProductOptionSwatch.size.swatchName,
			boostPFSFilterConfig.boostProductOptionSwatch.size.optionName,
			boostPFSFilterConfig.boostProductOptionSwatch.size.swatchDisplay,
			boostPFSFilterConfig.boostProductOptionSwatch.size.swatchType
		));

		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		// Member CTA placeholder
		itemHtml = itemHtml.replace(/{{itemMemberCTA}}/g, buildMemberCTA(data));

		return itemHtml;
	};

	// Build Product List Item (unchanged)
	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		data = prepareShopifyData(data);
		var itemHtml = boostPFSTemplate.productListItemHtml;

		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
			 typeof Integration.hascompileTemplate == 'function' &&
			 !Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(
			data,
			boostPFSFilterConfig.boostProductOptionSwatch.color.swatchName,
			boostPFSFilterConfig.boostProductOptionSwatch.color.optionName,
			boostPFSFilterConfig.boostProductOptionSwatch.color.swatchDisplay,
			boostPFSFilterConfig.boostProductOptionSwatch.color.swatchType
		));

        itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildProductOptionSwatches(
			data,
			boostPFSFilterConfig.boostProductOptionSwatch.size.swatchName,
			boostPFSFilterConfig.boostProductOptionSwatch.size.optionName,
			boostPFSFilterConfig.boostProductOptionSwatch.size.swatchDisplay,
			boostPFSFilterConfig.boostProductOptionSwatch.size.swatchType
		));

		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2: gridWidthClass = 'boost-pfs-filter-grid-width-2'; break;
			case 3: gridWidthClass = 'boost-pfs-filter-grid-width-3'; break;
			case 5: gridWidthClass = 'boost-pfs-filter-grid-width-5'; break;
			case 6: gridWidthClass = 'boost-pfs-filter-grid-width-6'; break;
			default: gridWidthClass = 'boost-pfs-filter-grid-width-4'; break;
		}
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1: gridWidthClass += ' boost-pfs-filter-grid-width-mb-1'; break;
			case 3: gridWidthClass += ' boost-pfs-filter-grid-width-mb-3'; break;
			default: gridWidthClass += ' boost-pfs-filter-grid-width-mb-2'; break;
		}
		return gridWidthClass;
	}

	// BUILD FEATURED IMAGE (unchanged)
	function buildFeaturedImage(data) {
		var html = '', aspectRatio = '', rangeWidths = boostPFSRangeWidths, paddingTop = 100;
		var dataSrcSet = '', dataWidths = '', dataSizes = 'auto', imgAlt = data.title;

		if (data.images_info.length > 1) {
			var featuredImageSrc = data.images_info[0].src;
			for (var i = 0; i < rangeWidths.length; i++) {
				dataSrcSet += featuredImageSrc.replace(".jpg", '_'+rangeWidths[i]+'x.jpg') + ' ' + rangeWidths[i] + 'w';
				dataWidths += rangeWidths[i];
				if (i < rangeWidths.length - 1) { dataSrcSet += ', '; dataWidths += ', '; }
			}
			if (images.length > 0) {
				aspectRatio = images[0]['width'] / images[0]['height'];
				paddingTop = 1 / aspectRatio * 100;
			}
			html += '<img js-product-card-featured-image data-image="' + data.id + '" class="boost-pfs-filter-product-item-main-image"' +
				'src="' + featuredImageSrc.replace(".jpg|.png", '_1024x.jpg') + '" ' +
				'alt="' + imgAlt + '" ' +
			'/>';
		}
		return html;
	}

	// BUILD VARIANT IMAGES (unchanged)
	function buildVariantImages(data) {
		var html = '';
		var variantColors = [];
		var conditions = 'raw,black,green,navy';

		if (data.variants.length > 1) {
			for (var i = 0; i < data.variants.length; i++) {
				var imgAlt = data.title;
				var variantImageSrc = data.variants[i].image;
				var swatchName = data.variants[i].title;
				var swatchNameHandle = swatchName.split(" / ")[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

				if (variantImageSrc == null) {
					variantImageSrc = data.images_info.length > 0 ? data.images_info[0].src : boostPFSConfig.general.no_image_url;
				}

				if (variantColors.indexOf(swatchName) === -1) {
					if (i == 0) {
						if (conditions.includes(swatchNameHandle)) {
							html += '<img js-product-card-variant-image data-image="' + data.id + '" data-value="' + data.id + '-' + swatchNameHandle + '" style="display: block;" class="boost-pfs-filter-product-item-main-image"' +
								'src="' + variantImageSrc.replace(".jpg", '_large.jpg') + '" ' +
								'alt="' + imgAlt + '" />';
						} else if (variantImageSrc.includes('jpg')) {
							html += '<img js-product-card-variant-image data-image="' + data.id + '" data-value="' + data.id + '-' + swatchNameHandle + '" style="display: block;" class="boost-pfs-filter-product-item-main-image"' +
								'src="' + variantImageSrc + '" ' +
								'alt="' + imgAlt + '" />';
						} else if (variantImageSrc.includes('png')) {
							html += '<img js-product-card-variant-image data-image="' + data.id + '" data-value="' + data.id + '-' + swatchNameHandle + '" style="display: block;" class="boost-pfs-filter-product-item-main-image"' +
								'src="' + variantImageSrc.replace(".png", '_large.png') + '" ' +
								'alt="' + imgAlt + '" />';
						}
					} else {
						if (conditions.includes(swatchNameHandle)) {
							html += '<img js-product-card-variant-image data-image="' + data.id + '" data-value="' + data.id + '-' + swatchNameHandle + '" style="display: none;" class="boost-pfs-filter-product-item-main-image"' +
								'src="' + variantImageSrc.replace(".jpg", '_large.jpg') + '" ' +
								'alt="' + imgAlt + '" />';
						} else if (variantImageSrc.includes('jpg')) {
							html += '<img js-product-card-variant-image data-image="' + data.id + '" data-value="' + data.id + '-' + swatchNameHandle + '" style="display: none;" class="boost-pfs-filter-product-item-main-image"' +
								'src="' + variantImageSrc + '" ' +
								'alt="' + imgAlt + '" />';
						} else if (variantImageSrc.includes('png')) {
							html += '<img js-product-card-variant-image data-image="' + data.id + '" data-value="' + data.id + '-' + swatchNameHandle + '" style="display: none;" class="boost-pfs-filter-product-item-main-image"' +
								'src="' + variantImageSrc.replace(".png", '_large.png') + '" ' +
								'alt="' + imgAlt + '" />';
						}
					}

					if (variantColors.indexOf(swatchName) === -1) {
					    variantColors.push(swatchName);
					}
				}
			}
		} else {
			var imgAlt2 = data.title;
			if (data.images_info.length >= 1) {
				var featuredImageSrc2 = data.images_info[0].src;
				if (featuredImageSrc2.includes('jpg')) {
					html += '<img js-product-card-featured-image data-image="' + data.id + '" class="boost-pfs-filter-product-item-main-image"' +
						'src="' + featuredImageSrc2 + '" ' +
						'alt="' + imgAlt2 + '" ';
				} else if (featuredImageSrc2.includes('png')) {
					html += '<img js-product-card-featured-image data-image="' + data.id + '" class="boost-pfs-filter-product-item-main-image"' +
						'src="' + featuredImageSrc2.replace(".png", '_large.png') + '" ' +
						'alt="' + imgAlt2 + '" ';
				}
				html += '/>';
			}
		}
    	return html;
	}

    // BUILD PRODUCTS TAGS (unchanged – your original placeholder)
    function builditemtags(data){
      var html = '';
      var variantColors = [];
      var conditions = 'raw,black,green,navy';
      /* ... existing tag code unchanged ... */
      return html;
	}

	// BUILD IMAGES (unchanged)
	function buildImages(data) {
		var html = '', aspectRatio = '', rangeWidths = boostPFSRangeWidths, paddingTop = 100;
		var dataSrcSet = '', dataWidths = '', dataSizes = 'auto', imgAlt = data.title, flipImageSrcSet = '';
		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			dataWidths += rangeWidths[i];
			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}
			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', '; dataWidths += ', ';
				if (activeSwapImage) { flipImageSrcSet += ', '; }
			}
		}
		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingTop = 1 / aspectRatio * 100;
		}
		html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" style="padding-top:' + paddingTop + '%;">';
		html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
			'data-srcset="' + dataSrcSet + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
			'data-widths="[' + dataWidths + ']" ' +
			'data-sizes="' + dataSizes + '" ' +
			'src="' + boostPFSImgDefaultSrc + '" ' +
			'alt="' + imgAlt + '" ';
		if (activeSwapImage) {
			html += 'data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x') + '" ' +
				'data-img-flip-srcset="' + flipImageSrcSet + '" ';
		}
		html += '/></a>';
		return html;
	}

	// BUILD VENDOR (unchanged)
	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor == true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	// MEMBER DISCOUNT (changed)
	function calculateMemberDiscount(data) {
		const isMemberSignUp = getMetaBool(data.metafields, 'seed', 'member_sign_up');
		const isMemberProduct = !!(data.collections || []).find(
			collection => memberCollections.has(collection.handle)
		);
		const membershipDiscount = window.CUSTOMER_MEMBERSHIP?.discount || {};
		let applicableDiscount = 0;
		if (isMemberProduct && window.CUSTOMER_MEMBERSHIP?.tier) {
			const memberCollection = (data.collections || []).find(
				collection => memberCollections.has(collection.handle)
			);
			if (memberCollection) {
				applicableDiscount = membershipDiscount[memberCollection.handle] || 0;
			}
		}
		const membershipDiscountAmount = applicableDiscount / 100;
		if (!isMemberProduct || membershipDiscountAmount === 0 || !window.CUSTOMER_MEMBERSHIP?.tier) {
			return {
				price_min: data.price_min,
				compare_at_price_min: data.compare_at_price_min,
				has_member_discount: false,
				is_member_sign_up: isMemberSignUp,
			};
		}
		return {
			price_min: data.price_min - membershipDiscountAmount,
			compare_at_price_min: Math.max(data.compare_at_price_min, data.price_min),
			has_member_discount: true,
			is_member_sign_up: isMemberSignUp,
		};
	}

	/* =========================
	   NEW: BUILD MEMBER CTA
	   ========================= */
	function buildMemberCTA(data) {
		var isLoggedIn = !!window.IS_LOGGED_IN;

		// Check if metafield exists
		var metafieldExists = false;
		if (data.metafields && Array.isArray(data.metafields)) {
			metafieldExists = data.metafields.some(function(m) {
				return (m.namespace === 'seed' && m.key === 'member_sign_up') || (m.key === 'seed.member_sign_up');
			});
		}

		// Primary read from Boost data
		var showCTA = getMetaBool(data.metafields, 'seed', 'member_sign_up');

		// Fallback: Liquid-injected map (only if metafield doesn't exist)
		if (!metafieldExists && window.PRODUCT_META && window.PRODUCT_META[data.id] !== undefined) {
			showCTA = !!window.PRODUCT_META[data.id];
		}

		// Only show if metafield true AND user logged out
		if (!showCTA || isLoggedIn) return '';

		// Optional savings message (based on compare_at vs price or metafield)
		var savingsCents = (typeof data.compare_at_price_min === 'number' && data.compare_at_price_min > data.price_min) ? 0 : 0;
    var discountAmount = data.metafields.filter(m => m.namespace === 'seed' && m.key == 'discount_amount');
    var showRivoDiscount = getMetaBool(data.metafields, 'seed', 'show_rivo_discount');  
    var discountMessage = data.metafields.filter(m => m.namespace === 'seed' && m.key == 'discount_message');

    var rivoCollections = Array.isArray(data.collections) ? data.collections.filter(function(collection) {
      return typeof collection.handle === 'string' && collection.handle.indexOf('rivo-') > -1;
    }): [];

    var labelText = 'Unlock member pricing';
    if (discountMessage.length > 0 && rivoCollections.length > 0) {
      labelText = discountMessage[0].value.replace('{$}', "$" + rivoCollections[0].handle.split('-')[1]);
    } else if (showRivoDiscount == true && rivoCollections.length > 0) {
      labelText = Utils.formatMoney(data.price_min - rivoCollections[0].handle.split('-')[1]);
    } else if (discountAmount.length > 0) {
      labelText = 'Unlock $' + discountAmount[0].value + ' OFF';
    }  else if (savingsCents > 0) {
      labelText = 'Unlock ' + Utils.formatMoney(savingsCents) + ' OFF';
    }

		// Debug logging toggle
		if (window.DEBUG_MEMBER_CTA) {
			console.log('[MemberCTA]', {
				title: data.title,
				id: data.id,
				isLoggedIn: isLoggedIn,
				metafields: data.metafields,
				liquidFallback: window.PRODUCT_META ? window.PRODUCT_META[data.id] : undefined,
				showCTA: showCTA
			});
		}

		return [
			'<div class="promotional-banner-tag" aria-live="polite">',
				'<a href="/account/register" class="promotional-banner-tag__link" data-track="member-cta">',
					'<span class="product-card__banner-text">', labelText, '</span>',
					'<span class="product-card__join-button">JOIN NOW</span>',
				'</a>',
			'</div>'
		].join('');
	}

	// BUILD PRICE (unchanged other than using calculateMemberDiscount)
	function buildPrice(data) {
		const isLoggedIn = window.IS_LOGGED_IN;
		const memberPrices = calculateMemberDiscount(data);

		if (memberPrices.price_min > memberPrices.compare_at_price_min) {
			console.warn(data, memberPrices);
		}

		var html = '';
		// Check if we should show member pricing badge
		var showMemberBadge = memberPrices.has_member_discount && isLoggedIn || memberPrices.is_member_sign_up && isLoggedIn;
		
		if (priceVaries) {
			html += '<span class="product-card__price--from">Starting: </span> ';
			html += '<span class="product-card__price--sale">' + Utils.formatMoney(memberPrices.price_min) + '</span>';
			if (showMemberBadge) {
				html += '<span class="product-card__price--member-discount">Member<br />Price</span>';
			}
		} else if (onSale || memberPrices.has_member_discount) {
			html += '<s class="product-card__price--compare">' + Utils.formatMoney(memberPrices.compare_at_price_min) + '</s> ';
			html += '<span class="product-card__price--sale">' + Utils.formatMoney(memberPrices.price_min) + '</span>';
			if (showMemberBadge) {
				html += '<span class="product-card__price--member-discount">Member<br />Price</span>';
			}
		} else {
			html += Utils.formatMoney(memberPrices.price_min);
			if (showMemberBadge) {
				html += '<span class="product-card__price--member-discount">Member<br />Price</span>';
			}
		}
		return html;
	}

	// BUILD LABELS (unchanged)
	function buildLabels(data) {
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
			boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		var saleLabel = '';
        var salePercent = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
            if (boostPFSThemeConfig.custom.show_sale_percent){
                salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_max);
            }
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
            saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{salePercent}}/g, salePercent + '%');
		}
		return soldOutLabel + saleLabel;
	}

	// BUILD LABEL PRODUCT WITH TAGS (unchanged)
	function buildTagLabels(data, showall) {
		if (boostPFSThemeConfig.custom.show_label_by_tag) {
			if (showall) {
				var tagLabel = '';
				if (data.tags) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
						}
					}
				}
			} else {
				var tagLabel = '';
				if (data.tags) {
					for (var i2 = data.tags.length - 1; i2 >= 0; i2--) {
						var tag2 = data.tags[i2];
						if (tag2.indexOf("pfs:label") !== -1) {
							var preTagLabel2 = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag2.split('pfs:label-')[1]);
							tagLabel += preTagLabel2;
							break;
						}
					}
				}
			}
			return tagLabel;
		} else {
			return "";
		}
	}

	// BUILD COLOR SWATCHES (unchanged)
	function buildProductOptionSwatches(data, swatchName, optionName, swatchDisplay, swatchType) {
		var swatchesProductOptionHtml = '',
			filterSwatchTitle = swatchName,
			optionName = optionName,
			swatchArr = [],
			available_color = [],
			countSwatch = 0,
			swatchValues = [],
			swatchLimit = 20;

		var dataImgSize = '360',
			bgSize = '50x',
			dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
			swatchName = '#ffffff',
			bgImageSrc = '',
			viewMoreLabel = 'More ' + filterSwatchTitle;

		if (swatchDisplay) {
            if (data.variants.length){
            	data.variants.forEach(function(element){
            		if (element.available){
            			var option_name = element.title.split(' / ');
            			if (!available_color.includes(option_name[0])){
            				available_color.push(option_name[0]);
            			}
            		}
            	});
            }

			function mapOrder (array, order, key) {
				array.sort( function (a, b) {
					var A = a[key], B = b[key];
					return (order.indexOf(A) > order.indexOf(B)) ? 1 : -1;
				});
				return array;
			};

			if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
				swatchArr = data.options_with_values.filter(function(option) {
					return option.name == optionName;
				});
				const variantOrder = data['variants'].map(function(variant){
					return variant.title.split(' / ')[0];
				});
				if (swatchArr && swatchArr.length > 0) {
					mapOrder(swatchArr[0].values, variantOrder, 'title');
				}
				if (swatchArr.length > 0) {
					countSwatch = swatchArr[0].values.length;
					if (swatchLimit > countSwatch) { swatchLimit = countSwatch; }
					swatchValues = swatchArr[0].values;

					swatchesProductOptionHtml += '<div class="swatch clearfix ' + optionName + ' collection-swatches">';
					swatchesProductOptionHtml += '<ul class="' + optionName + ' options">';

					for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
						swatchName = swatchValues[sIndex].title;
                        var swatchVariant = data['variants'][sIndex];
						var sImageIndex = swatchValues[sIndex].image || '';
						if (sImageIndex != '') {
							dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
						}

						if (swatchType) {
							switch (swatchType) {
								case 'swatch_color_display_type_image_color':
									bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(swatchName) + '.png?v=');
									break;
								case 'swatch_color_display_type_image_product':
									bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
									if (sImageIndex != '') {
										bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
									}
									break;
								default: bgImageSrc = '';
							}
						}

						var var_title = swatchVariant.title;
						var swatchNameHandle = swatchName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

						if (soldOut) {
							swatchesProductOptionHtml += '<li style="display: none;" class="swatch-element color ' + swatchNameHandle + '">';
						} else {
							swatchesProductOptionHtml += '<li class="swatch-element color ' + swatchNameHandle + '" data-price="' + swatchVariant.price + '">';
						}
						if (available_color.length > 0){
							available_color.forEach(function(v){
								if (v == swatchName){
									if (sIndex == 0) {
										swatchesProductOptionHtml += '<input js-product-card-swatch data-variant_title="'+var_title+'" data-handle="'+data.handle+'" data-value="' + data.id + '-' + swatchNameHandle + '" id="swatch-' + sIndex + '-' + swatchNameHandle + '-' + data.id + '"  data-id="' + data.id + '" type="radio" name="option-color-' + data.id + '" value="' + swatchNameHandle + '-' + data.id + '" checked/>';
									} else {
										swatchesProductOptionHtml += '<input js-product-card-swatch data-variant_title="'+var_title+'" data-handle="'+data.handle+'" data-value="' + data.id + '-' + swatchNameHandle + '" id="swatch-' + sIndex + '-' + swatchNameHandle + '-' + data.id + '"  data-id="' + data.id + '" type="radio" name="option-color-' + data.id + '" value="' + swatchNameHandle + '-' + data.id + '"/>';
									}
									swatchesProductOptionHtml += '<label for="swatch-' + sIndex + '-' + swatchNameHandle + '-' + data.id + '" style="background-color: ' + swatchNameHandle + '; background-image: url(' + bgImageSrc + '); background-size: cover;"></label>';
	        					}
	        				});
						}
						swatchesProductOptionHtml += '</li>';
					}

					swatchesProductOptionHtml += '</ul>';
					swatchesProductOptionHtml += '</div>';
				}
			}
		}
		return swatchesProductOptionHtml;
	}

	// Swatch events (unchanged)
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function() { img.attr('srcset', jQ(this).data('img')); });
			}
			if (event == 'click') {
				jQ(this).click(function() { img.attr('srcset', jQ(this).data('img')); });
			}
			jQ(this).focus(function() {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					img.attr('srcset', jQ(this).data('img'));
				}
			});
		});
	}

	// REVIEWS (unchanged)
	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	// ACTIVE SWAP CLASS (unchanged)
	function buildActiveSwapClass(data) {
		if (!Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true) {
			return 'has-bc-swap-image';
		}
		return '';
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Pagination (unchanged)
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		if (totalPage <= 1) { return ''; }

		var paginationHtml = boostPFSTemplate.paginateHtml;
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) { beforeCurrentPageArr.unshift('...'); }
		if (currentPage - 4 >= 0) { beforeCurrentPageArr.unshift(1); }
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) { afterCurrentPageArr.push('...'); }
		if (currentPage + 3 <= totalPage) { afterCurrentPageArr.push(totalPage); }

		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Sorting (unchanged)
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		var sortingArr = Utils.getSortingList();
		if (sortingArr) {
			var paramSort = Globals.queryParams.sort || '';
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
        		if(sortingArr[k] == "Manual" || sortingArr[k] == "Title ascending" || sortingArr[k] == "Title descending"){
          			continue;
        		}
				var activeClass = '';
				if (paramSort == k) { activeClass = 'boost-pfs-filter-sort-item-active'; }
				sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
			}
			html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}
		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	};

	ProductSorting.prototype.bindEvents = function() {
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			jQ('[js-collection-sort]').hide();
			jQ('[js-collection-filter-sort-trigger]').removeClass('active');
			jQ('[js-collection-sort-old]').hide();
			jQ('[js-collection-filter-sort-trigger-old]').removeClass('active');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function() {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});
	};

	// Display type (unchanged)
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
            }
		} else {
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
            }
		}
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);
		return itemHtml;
	};

    var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
    ProductDisplayType.prototype.render = function() {
        originalRenderProductDisplayType.call(this);

        if (this.$element.length) {
            this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
            this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
            if (Globals.queryParams.display == 'list') {
                this.$element.find(this.selector.productDisplayTypeList).addClass('active');
            } else if (Globals.queryParams.display == 'grid') {
		        if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
		            var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
		            this.$element.find(this.selector.productDisplayTypeGrid).each(function(){
			            var $parent = jQ(this).parent();
			            var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
			            var $activeClass = $cssNames[$cssNames.length - 1];
			            var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];

			            if($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass){
			                jQ(this).addClass('active');
			                jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
				                return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
			                }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
			            } else if(!$parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view').split('-')[1] == curentGridColumn) {
			                jQ(this).addClass('active');
			            }
		            });
		        } else {
		            this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
		        }
            }
        }
    };

	// Show Limit (unchanged)
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};

	// Breadcrumb (unchanged)
	Breadcrumb.prototype.compileTemplate = function(colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml;
	};

	/************************** END BUILD TOOLBAR **************************/

	// After render hooks (unchanged)
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
	};

	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS) {
			Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
				isScrolling = !1;
			}).on("touchmove", function() {
				isScrolling = !0;
			}).on("touchend", function() {
				isScrolling || (window.location = jQ(this).attr("href"));
			});
		}

		swapImage(data);

		if (Globals.queryParams.display !== 'list') {
			equalHeight(data);
		}

		jQ(window).resize(function() {
			if (Globals.queryParams.display !== 'list') {
				equalHeight(data);
			}
		});

		if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
			eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
		}

		if (typeof boostRemoveImageLoadingAnimation == 'function') {
			boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
		}

        /* Filter Sticky */
        if (boostPFSThemeConfig.custom.hasOwnProperty('enable_filter_sticky') && boostPFSThemeConfig.custom.enable_filter_sticky && !Utils.isMobile()) {
            if(jQ('.boost-pfs-filter-left-col-inner').length > 0){
                var stickyElemet = '.boost-pfs-filter-left-col-inner';
                var stickyElementParent = '.boost-pfs-filter-left-col';
                var startElement = '.boost-pfs-filter-products';
                jQ(stickyElemet).stickTo(startElement,stickyElementParent);
            }
        }

        /* Init Sticky Mobile */
        stickyFilterMobile();
        jQ(window).scroll(stickyFilterMobile);

        /* Init Sticky Horizontal */
        stickyFilterHorizontal();
        jQ(window).scroll(stickyFilterHorizontal);

		if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
			jQ('body').addClass('boost-pfs-filter-fullwidth-page');
		}
	};

    /* Filter Sticky (unchanged) */
    jQ.fn.stickTo = function(startElement, stickyElementParent) {
        var showingHeader = false;
        var headerHeight = 0;
        var headerSelector = '';
        var $window = jQ(window);
        var $startElement = jQ(startElement);
        var _this = this;
        var lastScrollTop = $window.scrollTop();

        var setPosition = function() {
	        var width = jQ(stickyElementParent).outerWidth();
	        var $windowHeight = $window.height();
	        var $contentHeight = $startElement.outerHeight(true);
	        var $contentTop = $startElement.offset().top;

	        var sidebarHeight = _this.outerHeight();
	        var sidebarTop = _this.offset().top;
	        var sidebarBottom = sidebarTop + sidebarHeight;

	        var scrollTop = $window.scrollTop();
	        var scrollBottom = scrollTop + $windowHeight;
	        var isScrollingDown = (scrollTop > lastScrollTop);

	        var endPos = $contentTop + $contentHeight;

	        if(jQ('.site-header-wrapper .action-area').length > 0){
	            headerSelector = '.site-header-wrapper .action-area';
	        } else if (jQ('.site-header .nav-bar').length > 0) {
	            headerSelector = '.site-header .nav-bar';
	        } else if (jQ('.site-header--fixed').length > 0) {
				headerSelector = '.site-header--fixed';
			} else if (jQ('.header-wrapper--fixed').length > 0) {
				headerSelector = '.header-wrapper--fixed';
			}
	        if(headerSelector != ''){
	        	headerHeight = jQ(headerSelector).outerHeight();
	        }

	        jQ(window).scroll(function(){
	            showingHeader = false;
	            if(jQ('.js-sticky-action-bar').length > 0 || jQ('.site-header .sticky--open').length > 0 || jQ('.site-header--fixed' || jQ('.header-wrapper--fixed'))){
	                showingHeader = true;
	            }
	        });

	        if (sidebarHeight > $contentHeight) {
	            _this.removeClass('boost-pfs-filter-stick');
	            jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
	            _this.css({ position: 'initial' });
	            return;
	        }

	        if (scrollTop <= $contentTop) {
	            _this.removeClass('boost-pfs-filter-stick');
	            jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
	            _this.css({ position: 'initial' });
	            return;
	        }

	        if ((scrollBottom >= endPos)) {
	            var absolutePos = endPos - sidebarHeight - $contentTop;
	            if (absolutePos > 0) {
	                _this.removeClass('boost-pfs-filter-stick');
	                jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
	                _this.css({ position: 'absolute', top: absolutePos, bottom: 'unset', width: width });
	            }
	            return;
	        }

	        if (isScrollingDown) {
	            if (scrollBottom < sidebarBottom) {
		            if (_this.css('position') !== 'relative') {
		                _this.removeClass('boost-pfs-filter-stick');
		                jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
		                _this.css({ position: 'relative', top: sidebarTop - $contentTop, bottom: 'unset' });
		            }
	            } else if (scrollBottom >= sidebarBottom && scrollTop > $contentTop) {
	                _this.addClass('boost-pfs-filter-stick');
	                jQ('body').addClass('boost-pfs-filter-stick-vertical-body');
	                _this.css({
	                    position: 'fixed',
	                    top: showingHeader ? (headerHeight + 'px') : '20px',
	                    bottom: $windowHeight > (sidebarHeight + headerHeight) ? 'unset' : 0,
	                    width: width,
	                    'max-height': 'calc(100vh - 50px)',
	                    overflow: 'auto',
	                    left: 'auto'
	                });
	            }
	        } else {
	            if ((scrollTop - headerHeight) > sidebarTop) {
		            if (_this.css('position') !== 'relative') {
		                _this.removeClass('boost-pfs-filter-stick');
		                jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
		                _this.css({ position: 'relative', top: sidebarTop - $contentTop, bottom: 'unset' });
		            }
	            } else if (scrollTop <= (endPos - sidebarHeight)) {
	                _this.addClass('boost-pfs-filter-stick');
	                jQ('body').addClass('boost-pfs-filter-stick-vertical-body');
	                _this.css({
	                    position: 'fixed',
	                    top:  showingHeader ? (headerHeight + 'px') : '20px',
	                    bottom: 'unset',
	                    width: width,
	                    'max-height': 'calc(100vh - 50px)',
	                    overflow: 'auto',
	                    left: 'auto'
	                });
	            }
	        }
	        lastScrollTop = $window.scrollTop();
        };

        jQ(window).resize(function() { setPosition(); });
        jQ(window).scroll(setPosition);
        setPosition();

        jQ(document).on('click', '.boost-pfs-filter-button.boost-pfs-filter-option-title-heading', function() {
            setTimeout(setPosition, 400);
        });
    };

    function stickyFilterMobile() {
        var windowTop = jQ(window).scrollTop();
		var heightFooter = 0;
        var divTop = 0;
        var divHeight = 0;
		if(jQ("#shopify-section-footer").length > 0){
			heightFooter = jQ("#shopify-section-footer").height();
		}
		if(jQ(".boost-pfs-filter-wrapper").length > 0){
			divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
		}
		if(jQ(".boost-pfs-filter-wrapper").length > 0){
			divHeight = jQ(".boost-pfs-filter-wrapper").height();
		}
        if (windowTop > divTop + divHeight - heightFooter){
            jQ('body').removeClass('boost-pfs-mobile-stick');
        } else if (windowTop > divTop) {
            jQ('body').addClass('boost-pfs-mobile-stick');
        } else {
            jQ('body').removeClass('boost-pfs-mobile-stick');
        }
    }

    function stickyFilterHorizontal() {
        if(jQ('.boost-pfs-filter-tree-h-sticky-filter').length > 0 && !Utils.isMobile()){
            var windowTop = jQ(window).scrollTop();
			var divTop = 0;
			if(jQ('.boost-pfs-filter-wrapper').length > 0){
				divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
			}
            if (windowTop > divTop) {
	            jQ('body').addClass('boost-pfs-filter-horizontal-sticky-body');
            } else {
	            jQ('body').removeClass('boost-pfs-filter-horizontal-sticky-body');
            }
        }
    }

	// Placeholder, swap image, equalHeight, etc. (unchanged)
	function boostRemoveImageLoadingAnimation($selector) {
		if ($selector.length) { $selector.removeAttr('data-boost-image-loading-animation'); }
	}

	function equalHeight(data) {
		var equal_i = -1;
		var equal_els = [];
		var equal_element = null;

		jQ('.boost-pfs-filter-product-item').each(function(i, element) {
			var offsetTop = jQ(element).offset().top;
			if (!equal_element || equal_element.offset().top !== offsetTop) {
				equal_element = jQ(element);
				equal_i++;
			}
			if (!equal_els[equal_i]) { equal_els[equal_i] = []; }
			equal_els[equal_i].push(element);
		});

		for (var i = 0; i < equal_els.length; i++) {
			var max = 0;
			for (var j = 0; j < equal_els[i].length; j++) {
				var item = equal_els[i][j];
				var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
				max = Math.max(max, height);
			}
			jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });
		}

		var equal_height = boostPFSFilterConfig.general.equal_height;

		if (equal_height != 'false') {
			var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;
			jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': '' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);
		}
	}

	function swapImage(data) {
		if (!Utils.isMobile()) {
			if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
				boostPFSThemeConfig.custom.active_image_swap == true) {
				var dataSrcSetFlipImg = '', dataSrcFlipImg = '', flipImageAlt = '', dataSizes = 'auto', dataWidths = '', html = '';

				jQ(".boost-pfs-filter-product-item").each(function() {
					var productItemSelector = jQ(this);
					var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

					if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
						imgSelector.data('img-flip-src') != '') {
						dataSrcFlipImg = imgSelector.data('img-flip-src');
						dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
						flipImageAlt = imgSelector.attr('alt');
						dataWidths = imgSelector.data('widths');
						html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
							'data-srcset="' + dataSrcSetFlipImg + '" ' +
							'data-src="' + dataSrcFlipImg + '" ' +
							'data-widths="[' + dataWidths + ']" ' +
							'data-sizes="' + dataSizes + '" ' +
							'src="' + boostPFSImgDefaultSrc + '" ' +
							'alt="' + flipImageAlt + '" />';
						productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
					}
				});
			}
		}
	}

  /* Expand Filter */
  jQ(document).ready(function() {
      jQ('.boost-pfs-filter-custom-filter-button').on('click', function(){
          jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
      });
      jQ('.boost-pfs-filter-custom-drawer-close').click(function(){
          jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
      });
      jQ('.boost-pfs-filter-custom-drawer-overlay').click(function(){
          jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
      });
  });

})();